function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["productId", "jsEvent"],
    _excluded2 = ["productId", "jsEvent"],
    _excluded3 = ["productId", "jsEvent"],
    _excluded4 = ["productId", "jsEvent"];

function cartPopupQtyIncClicked() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$productId = _ref.productId,
      productId = _ref$productId === void 0 ? '' : _ref$productId,
      _ref$jsEvent = _ref.jsEvent,
      jsEvent = _ref$jsEvent === void 0 ? {} : _ref$jsEvent,
      rest = _objectWithoutProperties(_ref, _excluded);

  return {
    type: 'cart-popup-inc-quantity-clicked',
    payload: _objectSpread2({
      productId: productId,
      jsEvent: jsEvent
    }, rest)
  };
}

function cartPopupQtyDecClicked() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$productId = _ref2.productId,
      productId = _ref2$productId === void 0 ? '' : _ref2$productId,
      _ref2$jsEvent = _ref2.jsEvent,
      jsEvent = _ref2$jsEvent === void 0 ? {} : _ref2$jsEvent,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return {
    type: 'cart-popup-dec-quantity-clicked',
    payload: _objectSpread2({
      productId: productId,
      jsEvent: jsEvent
    }, rest)
  };
}

function cartPopupRemoveItemClicked() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$productId = _ref3.productId,
      productId = _ref3$productId === void 0 ? '' : _ref3$productId,
      _ref3$jsEvent = _ref3.jsEvent,
      jsEvent = _ref3$jsEvent === void 0 ? {} : _ref3$jsEvent,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return {
    type: 'cart-popup-remove-item-clicked',
    payload: _objectSpread2({
      productId: productId,
      jsEvent: jsEvent
    }, rest)
  };
}

function cartPopupHeroImageClicked() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$productId = _ref4.productId,
      productId = _ref4$productId === void 0 ? '' : _ref4$productId,
      _ref4$jsEvent = _ref4.jsEvent,
      jsEvent = _ref4$jsEvent === void 0 ? {} : _ref4$jsEvent,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return {
    type: 'cart-popup-hero-image-clicked',
    payload: _objectSpread2({
      productId: productId,
      jsEvent: jsEvent
    }, rest)
  };
}

export { cartPopupHeroImageClicked, cartPopupQtyDecClicked, cartPopupQtyIncClicked, cartPopupRemoveItemClicked };